module.exports = __webpack_public_path__ + "img/banner.4c95f4a6.png";